const translations = {
    "topBar.serviceTitle": "AI Exchange .Live",
    "insightsPanel.panelTitle": "AI-Powered Market Insights",
    "insightsPanel.legalDisclaimer": "Note: The insights above are generated by AI and are for informational purposes only. AI Exchange does not guarantee the accuracy, completeness, or reliability of this data. These insights should not be considered financial advice, and we are not responsible for any decisions made based on this content. Use at your own discretion.",
    "currencyConverter.componentTitle": "Currency Converter",
    "currencyConverter.labelAmount": "Amount",
    "currencyConverter.labelFrom": "From",
    "currencyConverter.labelTo": "To",
    "currencyConverter.labelConvertedAmount": "Converted Amount",
    "currencyConverter.buttonConvert": "Convert",
    "pageSharePanel.tooltipCopyLink": "Copy link",
    "pageSharePanel.tooltipCopyLinkDone": "Link has been copied!",
    "pageSharePanel.tooltipShareOnWhatsapp": "Share on WhatsApp",
    "pageSharePanel.tooltipShareOnTwitter": "Share on Twitter",
    "pageSharePanel.tooltipShareOnFacebook": "Share on Facebook",
    "pageSharePanel.tooltipShareOnLinkedIn": "Share on LinkedIn",
    "pageSharePanel.tooltipShareOnEmail": "Send this page by email",
    "pageSharePanel.tooltipPrintPage": "Print the page",
}

export default translations;